import classNames from 'classnames';
import React from 'react';

import { Alert, AlertSize, AlertType } from '../../components/Alert/Alert';
import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { Bem } from '../../service/Bem/Bem';

import './CanvasFooter.css';

const BLOCK = 'canvas-footer';
type CanvasFooterProps = {
    cls?: string;
    submitEnabled: boolean;
    submitVisible: boolean;
    submitLabel: string;
    cancelLabel: string;
    error: { message: string } | undefined;
    hideError: () => void;
    submit: () => void;
    cancel: () => void;
};

export class CanvasFooter extends React.PureComponent<CanvasFooterProps> {
    render() {
        return (
            <div className={classNames(this.props.cls, Bem.cls(BLOCK, 'footer'))}>
                {this.props.error && (
                    <Alert
                        size={AlertSize.s}
                        className={Bem.cls(BLOCK, 'error')}
                        type={AlertType.error}
                        onClose={this.props.hideError}
                    >
                        <div>{this.props.error.message}</div>
                    </Alert>
                )}
                {this.props.submitVisible && (
                    <ButtonDecorator
                        cls={Bem.cls(BLOCK, 'footer-action')}
                        theme="action"
                        size="n"
                        text={this.props.submitLabel}
                        disabled={!this.props.submitEnabled}
                        onClick={this.props.submit}
                    />
                )}
                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'footer-action')}
                    theme="normal"
                    size="n"
                    text={this.props.cancelLabel}
                    onClick={this.props.cancel}
                />
            </div>
        );
    }
}
